define('TescoMobile_Customer/js/view/account/usage-history',['uiComponent', 'jquery', 'ko', 'Magento_Customer/js/customer-data', 'Magento_Ui/js/modal/modal'], function (Component, $, ko, customerData, modal) {
  'use strict';

  let popUp = null;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Customer/catalog/usage-history',
      usageGraphTemplate: 'TescoMobile_Customer/catalog/usage-history-popup',
      averageMonths: 0,
      averageUsage: 0,
      averageUsageUnits: '',
      legendStart: '12 months ago',
      legendInterm: '6 months ago',
      legendEnd: 'Latest bill',
      legendStartEl: '.legend-start',
      legendEndEl: '.legend-end',
      visible: false,
      useFullYear: false,
      isPopUpVisible: false,
      graphData: {}
    },
    initialize: function () {
      const usageHistory = customerData.get('usage-history');
      this._super();
      this.refreshUsageHistory(usageHistory());
      usageHistory.subscribe(this.refreshUsageHistory, this);
      this.getGraphData(usageHistory());
      this.isPopUpVisible.subscribe(function (value) {
        if (value) {
          this.getPopUp().openModal();
        }
      }.bind(this));
    },
    initObservable: function () {
      this._super();
      this.observe(['averageMonths', 'averageUsage', 'averageUsageUnits', 'visible', 'isPopUpVisible', 'graphData']);
      return this;
    },
    refreshUsageHistory: function (usageHistory) {
      var _usageHistory$data_ty;
      if (usageHistory !== null && usageHistory !== void 0 && (_usageHistory$data_ty = usageHistory.data_type_usage) !== null && _usageHistory$data_ty !== void 0 && _usageHistory$data_ty.usage_months && usageHistory.data_type_usage.usage_months > 0) {
        const maxUsageInMb = this.getMaxUsageInMb(usageHistory);
        const usageUnit = this.getUsageUnit(usageHistory);
        this.averageMonths(usageHistory.data_type_usage.usage_months);
        this.averageUsage(this.normaliseValue(usageUnit, usageHistory.data_type_usage.monthly_average, maxUsageInMb));
        this.averageUsageUnits(this.normaliseUsageUnit(usageUnit, maxUsageInMb));
        this.graphData = this.getGraphData(usageHistory);
        this.visible(true);
      } else {
        this.visible(false);
        this.graphData = {};
      }
    },
    showPopUp: function () {
      this.isPopUpVisible(true);
    },
    getPopUp: function () {
      if (!popUp) {
        const options = {
          type: 'slide',
          title: 'Usage history',
          trigger: 'usage-history-popup',
          modalClass: 'usage-history-popup',
          responsive: true,
          buttons: [],
          opened: function () {
            this.showProgressBars();
          }.bind(this),
          closed: function () {
            this.isPopUpVisible(false);
          }.bind(this)
        };
        popUp = modal(options, $('#usage-history-popup'));
      }
      return popUp;
    },
    normaliseValue: function (usageUnit, value, maxMonthUsage) {
      if (usageUnit === 'MB' && maxMonthUsage >= 1024) {
        return (value / 1024).toFixed(1);
      } else if (usageUnit === 'GB' && maxMonthUsage < 1) {
        return (value * 1024).toFixed(1);
      } else {
        return value;
      }
    },
    normaliseUsageUnit: function (usageUnit, maxMonthUsage) {
      if (usageUnit === 'MB' && maxMonthUsage >= 1024) {
        return 'GB';
      } else if (usageUnit === 'GB' && maxMonthUsage < 1) {
        return 'MB';
      } else {
        return usageUnit;
      }
    },
    getGraphData: function (usageHistory) {
      var _usageHistory$data_ty2, _usageHistory$data_ty3;
      if (!usageHistory || !((_usageHistory$data_ty2 = usageHistory.data_type_usage) !== null && _usageHistory$data_ty2 !== void 0 && _usageHistory$data_ty2.total_usage)) {
        return null;
      }
      const averageArray = (_usageHistory$data_ty3 = usageHistory.data_type_usage) === null || _usageHistory$data_ty3 === void 0 ? void 0 : _usageHistory$data_ty3.total_usage;
      let maxMonthUsageInMB = this.getMaxUsageInMb(usageHistory);
      const usageUnit = this.getUsageUnit(usageHistory);
      let rowsQty = 6,
        rowValuesArray = [],
        a = 0;
      let rearrangeArray = averageArray.map(function (item) {
        return {
          usage_month: item.usage_month,
          monthly_total: parseFloat(this.normaliseValue(usageUnit, item.monthly_total, maxMonthUsageInMB))
        };
      }.bind(this));
      const updatedUnit = this.normaliseUsageUnit(usageUnit, maxMonthUsageInMB);
      const roundVal = updatedUnit === 'MB' ? 0 : 1;
      rearrangeArray = rearrangeArray.reverse();
      maxMonthUsageInMB = maxMonthUsageInMB + maxMonthUsageInMB / 10;
      const precision = maxMonthUsageInMB >= 1 ? 1 : 2;
      const step = maxMonthUsageInMB / rowsQty;
      for (let i = 0; i < rowsQty; i++) {
        a = a + step;
        rowValuesArray.unshift(Number.parseFloat(this.normaliseValue('MB', a, maxMonthUsageInMB)).toFixed(roundVal));
      }
      return {
        data: usageHistory,
        rearrangeArray: rearrangeArray,
        maxUsage: this.normaliseValue('MB', maxMonthUsageInMB, maxMonthUsageInMB),
        usageUnit: updatedUnit,
        rowValuesArray: rowValuesArray,
        startDate: rearrangeArray[0].usage_month,
        finalDate: rearrangeArray[rearrangeArray.length - 1].usage_month,
        monthlyAvg: this.normaliseValue(usageUnit, usageHistory.data_type_usage.monthly_average, maxMonthUsageInMB),
        threeMonthAvg: this.normaliseValue(usageUnit, usageHistory.data_type_usage.three_months_avg, maxMonthUsageInMB),
        yearAvg: this.normaliseValue(usageUnit, usageHistory.data_type_usage.twelve_months_avg, maxMonthUsageInMB)
      };
    },
    getUsageUnit: function (usageHistory) {
      var _usageHistory$data_ty4;
      return (_usageHistory$data_ty4 = usageHistory.data_type_usage) === null || _usageHistory$data_ty4 === void 0 || (_usageHistory$data_ty4 = _usageHistory$data_ty4.usage_unit) === null || _usageHistory$data_ty4 === void 0 ? void 0 : _usageHistory$data_ty4.toUpperCase();
    },
    getMaxUsageInMb: function (usageHistory) {
      var _usageHistory$data_ty5;
      let maxMonthUsage = Math.max(...((_usageHistory$data_ty5 = usageHistory.data_type_usage) === null || _usageHistory$data_ty5 === void 0 ? void 0 : _usageHistory$data_ty5.total_usage.map(obj => obj.monthly_total)));
      if (this.getUsageUnit(usageHistory) === 'GB') {
        maxMonthUsage = maxMonthUsage * 1024;
      }
      return maxMonthUsage;
    },
    showProgressBars: function (elements) {
      const delay = (elements === null || elements === void 0 ? void 0 : elements.length) > 0 ? 50 : 0;
      setTimeout(function () {
        $('.progress').each(function (i) {
          const percentage = $(this).attr('aria-value') / $(this).attr('aria-valuemax') * 100;
          $(this).css('max-height', percentage + '%');
          if (percentage === 0) {
            $(this).css('border-bottom', '2px solid #00539f');
          }
        });
      }, delay);
    },
    previousPage: function (data, event) {
      $('.usage-graph__months').css('transform', `translate3d(0, 0, 0)`);
      $(this.legendStartEl).text(this.legendStart);
      $(this.legendEndEl).text(this.legendInterm);
      this.toggleButtons($(event.currentTarget));
    },
    nextPage: function (data, event) {
      const translateWidth = $('.usage-graph__item').width() * 6;
      $('.usage-graph__months').css('transform', `translate3d(-${translateWidth}px, 0, 0)`);
      $(this.legendStartEl).text(this.legendInterm);
      $(this.legendEndEl).text(this.legendEnd);
      this.toggleButtons($(event.currentTarget));
    },
    toggleButtons: function (element) {
      element.prop('disabled', true);
      element.siblings().prop('disabled', false);
    },
    showLegend: function () {
      let isDesktop = null;
      mediaCheck({
        media: '(min-width: 1008px)',
        entry: function () {
          isDesktop = true;
        },
        exit: function () {
          isDesktop = false;
        }
      });
      const start = this.isPopUpVisible() || !isDesktop ? this.legendInterm : this.legendStart;
      return {
        legendStart: start,
        legendEnd: this.legendEnd
      };
    }
  });
});

